import * as actionTypes from "constants/dashboard/actionTypes";
import { FETCH_STATUS } from "constants/fetchStatus";

const initialState = {
  errorMessage: "",
  stats: {},
  status: FETCH_STATUS.NONE
};

export default function dashboard(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_DASHBOARD_STATS:
      return {
        errorMessage: null,
        stats: {},
        status: FETCH_STATUS.FETCHING
      };
    case actionTypes.SET_DASHBOARD_STATS:
      return {
        errorMessage: null,
        stats: action.payload.stats,
        status: FETCH_STATUS.FETCHED
      };
    case actionTypes.SET_DASHBOARD_STATS_ERROR:
      return {
        errorMessage: action.payload.errorMessage,
        stats: {},
        status: FETCH_STATUS.ERROR
      };
    default:
      return state;
  }
}

export const selectDashboardStats = state => state.account.dashboard.stats;
export const selectDashboardErrorMessage = state =>
  state.account.dashboard.errorMessage;
export const selectDashboardStatus = state => state.account.dashboard.status;
